/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ProjectDtoModel, ProjectDtoModelType } from "./ProjectDtoModel"
import { ProjectDtoModelSelector } from "./ProjectDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  node: ProjectDtoModelType;
}

/**
 * ProjectDtoEdgeBase
 * auto generated base class for the model ProjectDtoEdgeModel.
 */
export const ProjectDtoEdgeModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectDtoEdge')
  .props({
    __typename: types.optional(types.literal("ProjectDtoEdge"), "ProjectDtoEdge"),
    cursor: types.union(types.undefined, types.string),
    node: types.union(types.undefined, MSTGQLRef(types.late((): any => ProjectDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectDtoEdgeModelSelector extends QueryBuilder {
  get cursor() { return this.__attr(`cursor`) }
  node(builder: string | ProjectDtoModelSelector | ((selector: ProjectDtoModelSelector) => ProjectDtoModelSelector) | undefined) { return this.__child(`node`, ProjectDtoModelSelector, builder) }
}
export function selectFromProjectDtoEdge() {
  return new ProjectDtoEdgeModelSelector()
}

export const projectDtoEdgeModelPrimitives = selectFromProjectDtoEdge().cursor
